<template>
    <div class="tc-modal-ar tc-modal-body">
        <div class="tc-modal-label">
            Дополненная реальность
        </div>
        <div class="tc-modal-text">
            Отсканируйте QR код камерой на мобильном устройстве:
        </div>
        <div class="tc-modal-qr-container" v-if="qrImageUrl">
            <img :src="qrImageUrl" alt="QR Code" class="tc-qr-image"/>
        </div>
        <div class="tc-modal-ar-or">
            <div class="tc-borderline-horizontal"></div>
            <div class="tc-or-text">или</div>
            <div class="tc-borderline-horizontal"></div>
        </div>
        <div class="tc-modal-text">
            Поделиться ссылкой:
        </div>
        <div class="tc-share-grid">
            <input class="tc-default-input"
                   readonly
                   :value="urlAR">
            <SquareOutlineButton @click="copyLink()">
                <template #icon>
                    <SVGCopy/>
                </template>
            </SquareOutlineButton>
        </div>
        <div class="tc-button-right">
            <OrangeButtonOfLawlessness :text="'Понятно'"
                                       :width="'150px'"
                                       @click="confirm()"/>
        </div>
    </div>
</template>

<script>
import SquareOutlineButton from '@/UI/CommonComponents/SquareOutlineButton.vue';
import SVGCopy from '@/UI/SVG/SVGCopy.vue';
import OrangeButtonOfLawlessness from '@/UI/CommonComponents/OrangeButtonOfLawlessness.vue';
import { useStoreUI } from '@/Store/storeUI';
import QRCode from 'qrcode';

export default {
    name: 'ModalAR',
    components: {
        OrangeButtonOfLawlessness,
        SVGCopy,
        SquareOutlineButton,
    },
    setup() {
        const storeUI = useStoreUI();
        return {
            storeUI,
        };
    },
    data() {
        return {
            urlAR: '',
            qrImageUrl: undefined,
        };
    },
    methods: {
        confirm() {
            this.storeUI.setIsShowModal(false);
        },
        getSearchString(url) {
            const index = url.indexOf('?');
            if (index !== -1 && index !== url.length - 1) {
                return url.slice(index);
            }
            return '';
        },
        async generateQRCode() {
            try {
                const url = await QRCode.toDataURL(this.urlAR);
                this.qrImageUrl = url;
            } catch (error) {
                console.error('Ошибка при генерации QR-кода:', error);
            }
        },
        copyLink() {
            navigator.clipboard.writeText(this.urlAR);
        },
    },
    mounted() {
        this.urlAR = window.location.origin + '/#/mobile/viewer' + this.getSearchString(window.location.href);
        this.generateQRCode();
    },
};
</script>

<style scoped lang="scss">
@import "CSS/modal";

.tc-modal-ar {
    width: 390px;
}

.tc-modal-qr-container {
    width: 100%;
    box-sizing: border-box;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.tc-modal-ar-or {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 10px;

}

.tc-or-text {
    color: #333333;
    font-size: 16px;
}

.tc-qr-image {
    height: 100%;
    aspect-ratio: 1/1;

}
</style>
